<tiptap-bubble-menu
  [editor]="editor()"
  [shouldShow]="shouldShowMenu"
  [options]="{ placement: 'top' }"
  pluginKey="customNodeMenu"
>
  <div
    role="toolbar"
    class="editor-menu p-1.5 shadow border rounded"
  >
    <div class="flex space-x-1 px-1">
      <button
        (click)="setAlignment('left')"
        [class.active]="isAlignLeft"
        [attr.aria-pressed]="isAlignLeft"
        [disabled]="!editor().can().setTextAlign('left')"
        type="button"
        matTooltip="Align Left"
        aria-label="Align Left"
        class="editor-menu-item"
      >
        <mat-icon
          fontIcon="align_horizontal_left"
          class="icon-sm icon-muted"
        ></mat-icon>
      </button>
      <button
        (click)="setAlignment('center')"
        [class.active]="isAlignCenter"
        [attr.aria-pressed]="isAlignCenter"
        [disabled]="!editor().can().setTextAlign('center')"
        type="button"
        matTooltip="Align Center"
        aria-label="Align Center"
        class="editor-menu-item"
      >
        <mat-icon
          fontIcon="align_horizontal_center"
          class="icon-sm icon-muted"
        ></mat-icon>
      </button>
      <button
        (click)="setAlignment('right')"
        [class.active]="isAlignRight"
        [attr.aria-pressed]="isAlignRight"
        [disabled]="!editor().can().setTextAlign('right')"
        type="button"
        matTooltip="Align Right"
        aria-label="Align Right"
        class="editor-menu-item"
      >
        <mat-icon
          fontIcon="align_horizontal_right"
          class="icon-sm icon-muted"
        ></mat-icon>
      </button>
    </div>
  </div>
</tiptap-bubble-menu>
